import { gql } from '@apollo/client'

const UPDATE_MERCHANT_COMPOSER = gql`
  mutation updateIntegrations($merchantId: uuid!, $setting: jsonb!) {
    update_merchants(
      where: { id: { _eq: $merchantId } }
      _append: { integration_settings: $setting }
    ) {
      affected_rows
      returning {
        integration_settings
      }
    }
  }
`
export { UPDATE_MERCHANT_COMPOSER }
